import React from 'react';
import CanvasWrapper from './components/CanvasWrapper';
import FatSpline from './components/lines/FatSpline';

const SplineScene: React.FC = () => (
    <CanvasWrapper>
        <FatSpline />
    </CanvasWrapper>
);

export default SplineScene;